module.exports = __webpack_public_path__ + "assets/best-sales-recruiters-rainmakers-2.247f4ed7.png";